export default "__VITE_ASSET__aLaI39yf__"